import Cookies from 'js-cookie';

export const TOKEN = 'token';

export const getToken = () => {
  return Cookies.get('next_auth') ?? localStorage.getItem(TOKEN);
};
